import * as mongoose from 'mongoose'
import { SubVertical } from 'common/constants'
import { MenuAttribute } from 'common/types/entities/mongo/sub/menuAttribute'
import { MenuType, MenuEnv } from 'common/constants/menu'
import { WindowProduct } from 'common/types/entities/mongo/product'

export interface Menu extends mongoose.Document {
  _id: string
  parentId: string
  name: string
  vertical: string
  subVertical: SubVertical
  wholeIds: string[]
  type: MenuType
  envs: MenuEnv[]
  order: number
  used: boolean
  deleted: boolean
  productCategories: string[]
  storeCategories: string[]
  brands: string[]
  channels: string[]
  tags: string[]
  productAttributes: MenuAttribute[]
  urlPc: string
  urlMobile: string
  alias: string
}

export interface DisplayMenu {
  id: string
  name: string
  alias: string
  type: MenuType
  productCategories: string[]
  pcLink?: string
  mobileLink?: string
}

export interface MenuLayer {
  displayMenus?: DisplayMenu[]
  selectedId?: string
}

export const ROOT_ID = '0'

export interface MenuAndProducts {
  menu: DisplayMenu
  products: WindowProduct[]
}
